import { render, staticRenderFns } from "./CompanyContent.vue?vue&type=template&id=17d80ea0&"
import script from "./CompanyContent.vue?vue&type=script&lang=js&"
export * from "./CompanyContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports